import { SystemProductSelectPtBr } from "./system-product-select-pt-br";

export const SYSTEM_PRODUCT_SELECT_FR_FR: SystemProductSelectPtBr = {
	label: "Produit de système",
	placeholder: "Sélectionner un produit de système",
	auxiliarSheet: {
		systemProducts: "Produits système",
		systemProductName: "Nom",
		systemProductSk: "SK",
		systemProductId: "ID",
	},
};
